import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "relative z-10",
  "aria-labelledby": "modal-title",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 transition-opacity bg-gray-900 bg-opacity-75" }, null, -1)
const _hoisted_3 = { class: "fixed inset-0 z-10 overflow-y-auto" }
const _hoisted_4 = { class: "flex items-end justify-center min-h-full p-4 text-center sm:items-center sm:p-0" }
const _hoisted_5 = { class: "relative w-full overflow-hidden text-left transition-all transform bg-white rounded shadow sm:my-8 sm:w-full sm:max-w-lg" }
const _hoisted_6 = { class: "bg-white" }
const _hoisted_7 = { class: "flex items-center justify-between border-b border-gray-400" }
const _hoisted_8 = { class: "w-full px-2 py-4 text-left" }
const _hoisted_9 = {
  class: "text-lg font-medium leading-6 text-gray-900",
  id: "modal-title"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-x-lg",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z" })
], -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = ["onSubmit"]
const _hoisted_13 = { class: "mt-4" }
const _hoisted_14 = { class: "relative inline-block w-full mt-4" }
const _hoisted_15 = { class: "block font-medium" }
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "relative inline-block w-full mt-4" }
const _hoisted_18 = { class: "block font-medium" }
const _hoisted_19 = ["value"]
const _hoisted_20 = { class: "flex justify-center px-4 pt-4 bg-gray-50" }

import { ref, watch, PropType } from "vue";

import DefaultButton from "../DefaultButton.vue";

import api from "@/api/api";
import { ClubDate, Goal } from "@/types";
import { useGlobalStore } from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'AddGoalProgressModal',
  props: {
  isOpen: {
    type: Boolean,
    required: true,
  },
  mode: {
    type: String,
    required: true,
  },
  isSavingGoal: {
    type: Boolean,
    required: true,
  },
  club_id: {
    type: Number,
    required: true,
  },
  member_id: {
    type: String,
    required: true,
  },
  dates: {
    type: Array as PropType<ClubDate[]>,
    required: true,
  },
  goal: {
    type: Object as PropType<Goal>,
    required: true,
  },
},
  emits: ["close", "fetch", "request-missing-dates"],
  setup(__props, { emit: emits }) {

const props = __props;




const globalStore = useGlobalStore();

const isSavingGoal = ref(false);

const goal = ref({} as Goal);
const goalProgress = ref(0 as number);
const sessionDateId = ref(0 as number);

const scores = ref([
  {
    key: "0 (no progress)",
    value: 0,
  },
  {
    key: "1",
    value: 1,
  },
  {
    key: "2",
    value: 2,
  },
  {
    key: "3",
    value: 3,
  },
  {
    key: "4",
    value: 4,
  },
  {
    key: "5 (halfway there)",
    value: 5,
  },
  {
    key: "6",
    value: 6,
  },
  {
    key: "7",
    value: 7,
  },
  {
    key: "8",
    value: 8,
  },
  {
    key: "9",
    value: 9,
  },
  {
    key: "10 (goal achieved)",
    value: 10,
  },
]);

function close() {
  emits("close");
}

async function saveGoalProgress() {
  try {
    isSavingGoal.value = true;
    await api.goals.updateGoalProgress(props.club_id, props.member_id, props.goal!.id, {
      session_date_id: sessionDateId.value,
      progress: goalProgress.value,
      goal_id: props.goal!.id,
    });

    globalStore.toast("SUCCESS", "Goal progress recorded");
    emits("request-missing-dates"); // Emit event after saving goal progress
  } catch (error) {
    console.log(error);
    globalStore.toast("ERROR", "Error recording Goal progress");
  }

  isSavingGoal.value = false;

  sessionDateId.value = 0;
  goalProgress.value = 0;

  return emits("fetch");
}

watch(
  () => props.isOpen,
  () => {
    console.log("props.isOpen", props.isOpen);
    if (props.isOpen && props.goal) {
      goal.value = props.goal;
    }
  }
);

return (_ctx: any,_cache: any) => {
  return (props.isOpen)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("h3", _hoisted_9, _toDisplayString(_ctx.$t("add-progress")), 1)
                  ]),
                  _createElementVNode("div", { class: "py-4 pl-2 pr-4" }, [
                    _createElementVNode("button", { onClick: close }, _hoisted_11)
                  ])
                ]),
                _createElementVNode("form", {
                  class: "px-4 pb-4 mt-4 border-b border-gray-400",
                  onSubmit: _withModifiers(saveGoalProgress, ["prevent"])
                }, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("p", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t("add-goal-helptext")), 1)
                    ]),
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t("score-key-no-label")), 1),
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t("score-key-description")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t("session-date")), 1),
                    _withDirectives(_createElementVNode("select", {
                      class: "block w-full px-3 py-2 mt-1 text-base bg-white border border-gray-600 rounded-md shadow-sm m1- focus:outline-none focus:ring focus:ring-blue-200 focus:ring-opacity-50",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((sessionDateId).value = $event)),
                      required: ""
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.dates, (date, index) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: date.id,
                          key: index
                        }, _toDisplayString(new Date(date.date).toDateString()), 9, _hoisted_16))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, sessionDateId.value]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t("goal-progress-label")), 1),
                    _withDirectives(_createElementVNode("select", {
                      class: "block w-full px-3 py-2 mt-1 text-base bg-white border border-gray-600 rounded-md shadow-sm m1- focus:outline-none focus:ring focus:ring-blue-200 focus:ring-opacity-50",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((goalProgress).value = $event)),
                      required: ""
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scores.value, (score, index) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: score.value,
                          key: index
                        }, _toDisplayString(score.key), 9, _hoisted_19))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, goalProgress.value]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(DefaultButton, {
                      type: "primary",
                      "is-form-submit": true,
                      disabled: isSavingGoal.value,
                      loading: isSavingGoal.value
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("save")), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled", "loading"])
                  ])
                ], 40, _hoisted_12)
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})